import { Navigate } from 'react-router-dom';
import { useFeatureFlags, VariantFlags } from '@/services/feature-flag-provider';
import { getQuizletConfig } from './quizlet-config';
import { ROUTE_QUIZLET_QUESTIONNAIRE } from '@/constants/routes';

/**
 * Enhanced variant redirect that supports all configured quizlet versions
 * Uses feature flags to determine which version to redirect to
 * 
 * IMPORTANT: v1 uses completely different components (not QuestionnaireV2)
 * so it's handled separately and redirects to ROUTE_QUIZLET_QUESTIONNAIRE
 */
const QuizletVariantRedirect = () => {
  const { getVariant, isLoading } = useFeatureFlags();
  const quizletVersion = getVariant(VariantFlags.QuizletVersion);

  // Wait for feature flags to load before redirecting
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Special handling for v1 - uses different component system
  if (quizletVersion === 'v1') {
    return <Navigate to={ROUTE_QUIZLET_QUESTIONNAIRE} replace />;
  }

  // Try to find the configuration for QuestionnaireV2-based versions
  const config = getQuizletConfig(quizletVersion);
  
  if (config && config.enabled) {
    // Redirect to the configured version's questionnaire path
    return <Navigate to={`${config.basePath}/questionnaire`} replace />;
  }

  // If version not found or disabled, fallback to v1 (original quizlet)
  return <Navigate to={ROUTE_QUIZLET_QUESTIONNAIRE} replace />;
};

export default QuizletVariantRedirect;